<template>
  <div>
    <titulo-boletim />
    <b-row>
      <b-col md="4">
        <input-select-search
          ref="anoLetivo"
          :label="$t('ACADEMICO.ANO_LETIVO')"
          v-model="filtro.anoLetivoId"
          :options="anosLetivos"
          @input="imprimirRelatorioBoletimNotasParciais"
          required
        />
      </b-col>
      <b-col md="8">
        <div class="d-flex botao-imprimir">
          <b-button @click="baixarBoletimPdf" variant="info" v-if="boletim">
            {{ $t("ACADEMICO.IMPRIMIR") }}</b-button
          >
        </div>
      </b-col>
    </b-row>

    <PdfViewer :boletim="boletim" v-if="boletim" />
  </div>
</template>
<script>
// utils e aux
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import pdf from "@/common/utils/pdf";
import mensagem from "@/common/utils/mensagem";

// services
import BoletimService from "@/common/services/boletim/boletim.service";
import AnoLetivoService from "@/common/services/ano-letivo/ano-letivo.service";

// Components:
import TituloBoletim from "./components/TituloBoletim";
import { InputSelectSearch } from "@/components/inputs";
import PdfViewer from "@/components/pdf-viewer/PdfViewer";

export default {
  components: {
    TituloBoletim,
    InputSelectSearch,
    PdfViewer,
  },
  data() {
    return {
      filtro: {
        anoLetivoId: "",
      },
      anosLetivos: [],
      boletim: null,
    };
  },
  mounted() {
    this.obterPeriodoLetivo();
  },
  methods: {
    obterPeriodoLetivo() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.obterPeriodoLetivo()
        .then(({ data }) => {
          this.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    imprimirRelatorioBoletimNotasParciais() {
      this.boletim = null;
      this.$store.dispatch(START_LOADING);
      BoletimService.imprimirRelatorioBoletimNotasParciais(
        this.filtro.anoLetivoId
      )
        .then((e) => {
          this.boletim = e.data;
        })
        .catch((err) => mensagem.showErrors(err))
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    baixarBoletimPdf() {
      let bytes = pdf.base64ToArrayBuffer(this.boletim.documento);
      // converte o array em blob
      let blob = new Blob([bytes], {
        type: "application/pdf",
      });
      // faz download do PDF:
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = this.boletim.nomeArquivo;
      link.click();
    },
    limparFiltro() {
      this.boletim = [];
    },
  },
};
</script>

<style>
.botao-imprimir {
  justify-content: flex-end;
  margin: 29px 0;
}
</style>
